const States = [
        {
            "id": 1,
            "word": "California",
            "pronunciation":  "🎵",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 2,
            "word": "Massachusetts",
            "pronunciation":  "🎵",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 3,
            "word": "Maine",
            "pronunciation":  "🎵",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 4,
            "word": "New Hampshire",
            "pronunciation":  "🎵",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 5,
            "word": "New York",
            "pronunciation":  "🎵",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 6,
            "word": "New Jersey",
            "pronunciation":  "🎵",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 7,
            "word": "Pennsylvania",
            "pronunciation":  "🎵",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 8,
            "word": "Illinois",
            "pronunciation":  "🎵",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 9,
            "word": "Ohio",
            "pronunciation":  "🎵",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 10,
            "word": "Georgia",
            "pronunciation":  "🎵",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 11,
            "word": "Texas",
            "pronunciation":  "🎵",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 12,
            "word": "North Carolina",
            "pronunciation":  "🎵",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 13,
            "word": "Michigan",
            "pronunciation":  "🎵",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 14,
            "word": "Virginia",
            "pronunciation":  "🎵",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 15,
            "word": "Washington",
            "pronunciation":  "🎵",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 16,
            "word": "Arizona",
            "pronunciation":  "🎵",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 17,
            "word": "Tennessee",
            "pronunciation":  "🎵",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 18,
            "word": "Indiana",
            "pronunciation":  "🎵",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 19,
            "word": "Maryland",
            "pronunciation":  "🎵",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 20,
            "word": "Missouri",
            "pronunciation":  "🎵",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 21,
            "word": "Wisconsin",
            "pronunciation":  "🎵",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 22,
            "word": "Colorado",
            "pronunciation":  "🎵",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 23,
            "word": "Minnesota",
            "pronunciation":  "🎵",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 24,
            "word": "South Carolina",
            "pronunciation":  "🎵",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 25,
            "word": "Alabama",
            "pronunciation":  "🎵",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 26,
            "word": "Louisiana",
            "pronunciation":  "🎵",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 27,
            "word": "Kentucky",
            "pronunciation":  "🎵",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 28,
            "word": "Oregon",
            "pronunciation":  "🎵",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 29,
            "word": "Oklahoma",
            "pronunciation":  "🎵",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 30,
            "word": "Connecticut",
            "pronunciation":  "🎵",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 31,
            "word": "Utah",
            "pronunciation":  "🎵",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 32,
            "word": "Iowa",
            "pronunciation":  "🎵",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 33,
            "word": "Nevada",
            "pronunciation":  "🎵",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 34,
            "word": "Arkansas",
            "pronunciation":  "🎵",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 35,
            "word": "Mississippi",
            "pronunciation":  "🎵",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 36,
            "word": "Kansas",
            "pronunciation":  "🎵",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 37,
            "word": "New Mexico",
            "pronunciation":  "🎵",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 38,
            "word": "Nebraska",
            "pronunciation":  "🎵",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 39,
            "word": "Idaho",
            "pronunciation":  "🎵",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 40,
            "word": "West Virginia",
            "pronunciation":  "🎵",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 41,
            "word": "Hawaii",
            "pronunciation":  "🎵",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 42,
            "word": "Rhode Island",
            "pronunciation":  "🎵",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 43,
            "word": "Montana",
            "pronunciation":  "🎵",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 44,
            "word": "Delaware",
            "pronunciation":  "🎵",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 45,
            "word": "South Dakota",
            "pronunciation":  "🎵",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 46,
            "word": "North Dakota",
            "pronunciation":  "🎵",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 47,
            "word": "Alaska",
            "pronunciation":  "🎵",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 48,
            "word": "Vermont",
            "pronunciation":  "🎵",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 49,
            "word": "Wyoming",
            "pronunciation":  "🎵",
            "progress": [
                0,
                0,
                0
            ]
        },
        {
            "id": 50,
            "word": "Florida",
            "pronunciation":  "🎵",
            "progress": [
                0,
                0,
                0
            ]
        }
    ];
  export default States;